<template>
  <div class="wish-list-item--for-edit-limit">
    <div class="wish-list-item--for-edit-limit__information-area">
      <WishListItemSkuBasicInformation
        :image-url="imageUrl"
        :brand-name="brandName"
        :item-name="itemName"
        :item-sku-name="itemSkuName"
        :item-id="itemId"
        :item-sku-id="itemSkuId"
        :is-sold-out="isSoldOut"
        class="wish-list-item--for-edit-limit__sku-basic-information"
      />
    </div>
    <div class="wish-list-item--for-edit-limit__form-area">
      <div class="wish-list-item--for-edit-limit__use-setting-area">
        <label :for="'use-setting-' + itemSkuId">
          <div :class="useSettingCheckboxClass">
            <input
              :id="'use-setting-' + itemSkuId"
              v-model="inputUseSettingChecked"
              type="checkbox"
            />個数を設定する
          </div>
        </label>
      </div>
      <div class="wish-list-item--for-edit-limit__quantity-input-area">
        <input
          type="number"
          class="wish-list-item--for-edit-limit__quantity-input input-form"
          placeholder="0"
          :class="quantityInputClass"
          :value="wantedQuantity"
          :disabled="!isUseChecked || null"
          @change="inputQuantity"
          @focus="onQuantityInputFocus"
          @blur="onQuantityInputBlur"
        />
      </div>
    </div>
  </div>
</template>
<script>
import WishListItemSkuBasicInformation from '../../atoms/wish_list/WishListItemSkuBasicInformation.vue'

export default {
  components: {
    WishListItemSkuBasicInformation
  },
  props: {
    imageUrl: {
      type: String,
      required: true
    },
    itemName: {
      type: String,
      required: true
    },
    itemSkuName: {
      type: String,
      required: false,
      default: ''
    },
    brandName: {
      type: String,
      required: true
    },
    itemId: {
      type: Number,
      required: true
    },
    itemSkuId: {
      type: Number,
      required: true
    },
    isUseSettingChecked: {
      type: Boolean,
      required: true
    },
    isSoldOut: {
      type: Boolean,
      required: true
    },
    wantedQuantity: {
      type: Number || null,
      required: false,
      default: 0
    },
    hasQuantityError: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      isUseChecked: false,
      isQuantityInputFocused: false,
      isQuantityInputted: false
    }
  },
  computed: {
    inputUseSettingChecked: {
      get() {
        return this.$props.isUseSettingChecked
      },
      set(value) {
        this.$emit('click-use-setting-checkbox', value)
        this.isUseChecked = value
      }
    },
    useSettingCheckboxClass() {
      return this.isUseChecked ? 'checkbox--checked' : 'checkbox'
    },
    quantityInputClass() {
      if (!this.isUseChecked) {
        return 'wish-list-item--for-edit-limit__quantity-input--disabled'
      }

      if (this.hasQuantityError) {
        return 'wish-list-item--for-edit-limit__quantity-input--error'
      }

      return this.isQuantityInputFocused
        ? 'input-form--inputting'
        : 'input-form--inputted'
    }
  },
  mounted() {
    this.isUseChecked = this.isUseSettingChecked
  },
  methods: {
    onQuantityInputFocus() {
      this.isQuantityInputFocused = true
    },
    onQuantityInputBlur() {
      this.isQuantityInputFocused = false
    },
    inputQuantity(event) {
      this.$emit('input-quantity', event.target.value)
    }
  }
}
</script>
<style lang="scss" scoped>
.wish-list-item {
  &--for-edit-limit {
    max-width: $small-contents-width;
    padding: 16px;
    margin: auto;
    border-top: 1px solid $gray-2;

    &__information-area {
      display: flex;
      align-items: center;
    }

    &__sku-basic-information {
      width: 100%;
      overflow-x: hidden;
    }

    &__form-area {
      margin-top: 16px;
      display: flex;
      align-items: center;
      gap: 16px;
    }

    &__use-setting-area {
      flex-basis: 50%;
      display: flex;
      justify-content: left;
    }

    &__quantity-input-area {
      flex-basis: 50%;
      height: 50px;
    }

    &__quantity-input {
      text-align: center;

      &--disabled {
        background-color: $gray-2;
        color: $gray-1;
      }

      &--error {
        background-color: $white;
        border-color: $danger;
      }
    }
  }
}
</style>
